import React from 'react'
import MaxWidthWrapper from '../wrappers/MaxWidthWrapper';
import { Link, useLocation } from 'react-router-dom';

const MainLayout = ({ children }: { children: React.ReactNode }) => {
  const navName = useLocation();

  return (
    <MaxWidthWrapper>
      <div className='imm_admin__main_layout'>
        <div className='nav'>
          <Link to={"/categories"} className={`${navName.pathname === '/categories' ? 'main_layout__select_nav' : ''}`}>Categories</Link>
          <Link to={"/notifications"} className={`${navName.pathname === '/notifications' ? 'main_layout__select_nav' : ''}`}>Notifications</Link>
          <Link to={"/custom-notifications"} className={`${navName.pathname === '/custom-notifications' ? 'main_layout__select_nav' : ''}`}>Custom Notifications</Link>
        </div>
        {children}
      </div>
    </MaxWidthWrapper>
  );
};

export default MainLayout;